var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful-image-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["entry", "altText", "isLazy"], 
["source_srcset", "imgsrc", "alternateImageQuality", "primaryImageQuality", "imgSrc_type", "srcset_type"], 
function (l_entry, l_altText, l_isLazy, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", l_entry);
frame.set("altText", l_altText);
frame.set("isLazy", l_isLazy);
frame.set("source_srcset", kwargs.hasOwnProperty("source_srcset") ? kwargs["source_srcset"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("imgsrc", kwargs.hasOwnProperty("imgsrc") ? kwargs["imgsrc"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("alternateImageQuality", kwargs.hasOwnProperty("alternateImageQuality") ? kwargs["alternateImageQuality"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("primaryImageQuality", kwargs.hasOwnProperty("primaryImageQuality") ? kwargs["primaryImageQuality"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("imgSrc_type", kwargs.hasOwnProperty("imgSrc_type") ? kwargs["imgSrc_type"] : "image/jpeg");
frame.set("srcset_type", kwargs.hasOwnProperty("srcset_type") ? kwargs["srcset_type"] : "image/jpeg");
var t_2 = "";var t_3;
t_3 = (l_isLazy?"medium":"(min-width: 768px)");
frame.set("media", t_3, true);
if(frame.topLevel) {
context.setVariable("media", t_3);
}
if(frame.topLevel) {
context.addExport("media", t_3);
}
t_2 += "\n    ";
var t_4;
t_4 = (l_isLazy?"data-srcset":"srcset");
frame.set("srcset", t_4, true);
if(frame.topLevel) {
context.setVariable("srcset", t_4);
}
if(frame.topLevel) {
context.addExport("srcset", t_4);
}
t_2 += "\n    ";
var t_5;
t_5 = (l_isLazy?"data-src":"src");
frame.set("src", t_5, true);
if(frame.topLevel) {
context.setVariable("src", t_5);
}
if(frame.topLevel) {
context.addExport("src", t_5);
}
t_2 += "\n\n    <picture data-qa-image-component>\n\n        ";
if(!(lineno = 16, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.thirdParty.moduleImages",runtime.contextOrFrameLookup(context, frame, "True")]))) {
t_2 += "\n\n            <img\n                style=\"width: 100%;\"\n                ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "src"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue((lineno = 20, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.thirdParty.moduleImageSrc",""])), env.opts.autoescape);
t_2 += "\"\n                alt=\"";
t_2 += runtime.suppressValue(l_altText, env.opts.autoescape);
t_2 += "\"\n                ";
if(l_isLazy) {
t_2 += " class=\"lazyload\" ";
;
}
t_2 += "\n                class=\"c-contentful-image\"\n                data-qa-contentful-image />\n\n        ";
;
}
else {
t_2 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "source_srcset")) {
t_2 += "\n\n                ";
if(!runtime.contextOrFrameLookup(context, frame, "alternateImageQuality") && (lineno = 30, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"experience.reduced"]))) {
t_2 += "\n\n                    ";
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality");
frame.set("alternateImageQuality", t_6, true);
if(frame.topLevel) {
context.setVariable("alternateImageQuality", t_6);
}
if(frame.topLevel) {
context.addExport("alternateImageQuality", t_6);
}
t_2 += "\n\n                ";
;
}
t_2 += "\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "alternateImageQuality")) {
t_2 += "\n\n                    ";
t_2 += "\n                    <source\n                        media=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "media"), env.opts.autoescape);
t_2 += "\"\n                        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "source_srcset"),runtime.makeKeywordArgs({"quality": runtime.contextOrFrameLookup(context, frame, "alternateImageQuality")})),"fm=webp"), env.opts.autoescape);
t_2 += "\" type=\"image/webp\" data-qa-contentful-alt-source />\n\n                    ";
t_2 += "\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "srcset_type") == "image/jpeg") {
t_2 += "\n\n                        <source\n                            media=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "media"), env.opts.autoescape);
t_2 += "\"\n                            ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "source_srcset"),runtime.makeKeywordArgs({"quality": runtime.contextOrFrameLookup(context, frame, "alternateImageQuality")})),"fm=jpg&fl=progressive"), env.opts.autoescape);
t_2 += "\"\n                            type=\"image/jpeg\" />\n\n                    ";
;
}
t_2 += "\n\n                    ";
t_2 += "\n                    <source\n                        media=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "media"), env.opts.autoescape);
t_2 += "\"\n                        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "source_srcset"),runtime.makeKeywordArgs({"quality": runtime.contextOrFrameLookup(context, frame, "alternateImageQuality")})), env.opts.autoescape);
t_2 += "\" data-qa-contentful-alt-source />\n\n                ";
;
}
else {
t_2 += "\n\n\n                    ";
t_2 += "\n                    <source\n                        media=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "media"), env.opts.autoescape);
t_2 += "\"\n                        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "source_srcset")),"fm=webp"), env.opts.autoescape);
t_2 += "\" type=\"image/webp\" />\n\n                    ";
t_2 += "\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "srcset_type") == "image/jpeg") {
t_2 += "\n\n                        <source\n                            media=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "media"), env.opts.autoescape);
t_2 += "\"\n                            ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "source_srcset")),"fm=jpg&fl=progressive"), env.opts.autoescape);
t_2 += "\"\n                            type=\"image/jpeg\" />\n\n                    ";
;
}
t_2 += "\n\n                    ";
t_2 += "\n                    <source\n                        media=\"";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "media"), env.opts.autoescape);
t_2 += "\"\n                        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "source_srcset")), env.opts.autoescape);
t_2 += "\" data-qa-contentful-alt-source/>\n\n                ";
;
}
t_2 += "\n\n            ";
;
}
t_2 += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "imgsrc")) {
t_2 += "\n\n                ";
if(!runtime.contextOrFrameLookup(context, frame, "primaryImageQuality") && (lineno = 87, colno = 61, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "core"),"experience.reduced"]))) {
t_2 += "\n\n                    ";
var t_7;
t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality");
frame.set("primaryImageQuality", t_7, true);
if(frame.topLevel) {
context.setVariable("primaryImageQuality", t_7);
}
if(frame.topLevel) {
context.addExport("primaryImageQuality", t_7);
}
t_2 += "\n\n                ";
;
}
t_2 += "\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "primaryImageQuality")) {
t_2 += "\n\n                    ";
t_2 += "\n                    <source\n                        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "imgsrc"),runtime.makeKeywordArgs({"quality": runtime.contextOrFrameLookup(context, frame, "primaryImageQuality")})),"fm=webp"), env.opts.autoescape);
t_2 += "\"\n                        type=\"image/webp\" data-qa-contentful-primary-source />\n\n                    ";
t_2 += "\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "srcset_type") == "image/jpeg") {
t_2 += "\n\n                        <source\n                            ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "imgsrc"),runtime.makeKeywordArgs({"quality": runtime.contextOrFrameLookup(context, frame, "primaryImageQuality")})),"fm=jpg&fl=progressive"), env.opts.autoescape);
t_2 += "\"\n                            type=\"image/jpeg\" />\n\n                    ";
;
}
t_2 += "\n\n                    ";
t_2 += "\n                    <img\n                        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "src"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "imgsrc"),runtime.makeKeywordArgs({"quality": runtime.contextOrFrameLookup(context, frame, "primaryImageQuality")})), env.opts.autoescape);
t_2 += "\"\n                        alt=\"";
t_2 += runtime.suppressValue(l_altText, env.opts.autoescape);
t_2 += "\"\n                        ";
if(l_isLazy) {
t_2 += " class=\"lazyload\" ";
;
}
t_2 += "\n                        class=\"c-contentful-image\"\n                        data-qa-contentful-image />\n\n                ";
;
}
else {
t_2 += "\n\n                    ";
t_2 += "\n                    <source\n                        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "imgsrc")),"fm=webp"), env.opts.autoescape);
t_2 += "\"\n                        type=\"image/webp\" data-qa-contentful-primary-source />\n\n                    ";
t_2 += "\n                    ";
if(runtime.contextOrFrameLookup(context, frame, "srcset_type") == "image/jpeg") {
t_2 += "\n\n                        <source\n                            ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcset"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("append_param_string").call(context, env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "imgsrc")),"fm=jpg&fl=progressive"), env.opts.autoescape);
t_2 += "\"\n                            type=\"image/jpeg\" />\n\n                    ";
;
}
t_2 += "\n\n                    ";
t_2 += "\n                    <img\n                        ";
t_2 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "src"), env.opts.autoescape);
t_2 += "=\"";
t_2 += runtime.suppressValue(env.getFilter("image_quality").call(context, runtime.contextOrFrameLookup(context, frame, "imgsrc")), env.opts.autoescape);
t_2 += "\"\n                        alt=\"";
t_2 += runtime.suppressValue(l_altText, env.opts.autoescape);
t_2 += "\"\n                        ";
if(l_isLazy) {
t_2 += " class=\"lazyload\" ";
;
}
t_2 += "\n                        data-qa-contentful-image />\n\n                ";
;
}
t_2 += "\n\n            ";
;
}
t_2 += "\n\n        ";
;
}
t_2 += "\n\n    </picture>";
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("renderContentfulPictureElement");
context.setVariable("renderContentfulPictureElement", macro_t_1);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful-image-macro.j2"] , dependencies)